// Centralized data-testid constants for stable automated testing
export const NAV = {
  brand: "nav-brand",
  linkCurriculum: "nav-link-curriculum",
  linkSystems: "nav-link-systems",
  linkAbout: "nav-link-about",
  linkPricing: "nav-link-pricing",
  cta: "nav-cta-enroll",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  scrollCue: "hero-scroll-cue",
};

export const LEAD = {
  form: "lead-form",
  emailInput: "lead-email-input",
  nameInput: "lead-name-input",
  submit: "lead-submit-button",
  success: "lead-success-message",
  error: "lead-error-message",
};

export const FINAL_CTA = {
  enroll: "final-cta-enroll",
};

export const SECTION = {
  pain: "section-pain",
  shift: "section-shift",
  proof: "section-proof",
  modules: "section-modules",
  approach: "section-approach",
  audience: "section-audience",
  founder: "section-founder",
  guarantee: "section-guarantee",
  certification: "section-certification",
  finalCta: "section-final-cta",
};

export const MODULE = (i) => `module-card-${i}`;
export const SYSTEM = (i) => `system-card-${i}`;
